import React from "react";

interface SelectProps {
  label?: string;
  value: string;
  options:
    | string[]
    | Array<{
        id: string;
        label: string;
        style?: { [attribute: string]: string };
      }>;
  onChange: (value: string) => void;
  className?: string;
  required?: boolean;
  infoText?: string;
}

const Select: React.FC<SelectProps> = ({
  label,
  value,
  options,
  onChange,
  className = "",
  required = false,
  infoText,
}) => {
  const isObjectOptions = options.length > 0 && typeof options[0] === "object";

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {infoText && <p className="text-gray-600 text-sm">{infoText}</p>}
      <select
        id={`select-${label?.toString().toLowerCase().split(" ").join("-")}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
      >
        {isObjectOptions
          ? (
              options as Array<{
                id: string;
                label: string;
                style?: { [attribute: string]: string };
              }>
            ).map((option) => (
              <option key={option.id} value={option.id} style={option.style}>
                {option.label}
              </option>
            ))
          : (options as string[]).map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
      </select>
    </div>
  );
};

export { Select };
